import { Select } from '@framework/ui/components/select/Select.tsx';
import { Typography } from 'antd';
import styled from 'styled-components';

export const ExportFieldFieldsSelectText = styled(Typography.Paragraph)`
  &&& {
    margin-bottom: 0;
    .anticon {
      color: ${props => props.theme.colorPrimary};
    }
  }
`;

export const DescriptionWrapper = styled.div`
  order: 0;
`;

export const FieldSelect = styled(Select)`
  &&& {
    width: 100%;
    order: 2;
  }
`;

export const MaxSelectableText = styled(ExportFieldFieldsSelectText)`
  &&& {
    order: 2;
  }
`;
